<template>
  <v-layout class="openended-design" fill-height column>
    <!-- <v-checkbox
      v-model="q.enabled"
      v-validate="'required'"
      :label="openendedStatusLabel"
      data-vv-name="checkbox"
      type="checkbox"
      @change="$emit('change', q)"
      required
    ></v-checkbox> -->
    <v-layout align-start class="open-ended-status mt-3">
      <v-layout align-center>
        <span class="design-label">
          Logic: 
        </span>
        <v-select
            class="lg-select"
            :items="openendedStatuses"
            item-text="label"
            item-value="id"
            solo
            v-model="q.enabled"
            style="height: 40px; max-width: 265px;"
            @change="q.question.length > 0 && $emit('change', q)" 
          ></v-select>
      </v-layout>
    </v-layout>
    <v-layout align-center column>
      <v-layout class="openended-question" :class="{'disabled': q.enabled === 'NONE'}" align-start>
        <div style="display:flex;align-items: center">
          <span class="design-label">
            Question: 
          </span>
          <textarea
            class="lgrm-box-input"
            v-model="q.question"
            placeholder="Type your question here..."
            :disabled="!q.enabled"
            @input="q.question.length > 0 && $emit('change', q)"
          />
          <div class="error--text" v-if="q.enabled && q.length === 0">
            Please enter a value or disable driver question
          </div>
        </div>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import constants from '@/constants'
export default {
  name: 'OpenendedDesign',
  props: {
    openendedStatusLabel: {
      type: String,
      default: 'Enable open-ended suggestion for'
    },
    question: {
      type: Object,
      default: function() {
        return {
          id: null,
          question: 'Please tell us what could be improved?',
          options: [
            { id: 1, label: 'Option 1', order_no: 1 },
            { id: 2, label: 'Option 2', order_no: 2 },
            { id: 3, label: 'Option 3', order_no: 3 }
          ]
        }
      }
    }
  },
  data: function() {
    return {
      q: this.question,
      openendedStatuses: constants.questionLogicItems
    }
  }
}
</script>

<style lang="stylus">
.openended-design {
    text-align center
    .open-ended-status {
      
      .v-label {
        color: $color-primary
      }
    }
    .open-ended-status-label {
      padding-right: 15px  
    }
    .openended-question.disabled {
      opacity: .3
      
    }
    .v-input--checkbox {
        .v-label {
            color: $color-primary-light-1
        }
    }
    .v-container{
        padding 0
    }
    textarea.lgrm-box-input {
        min-width 300px
    }
    .openended-question {
      flex: auto
    }
}
</style>
